module.exports = __webpack_public_path__ + "static/media/file-generic.873004bc.svg";